// Global util's for app
/*************************************************************/
// 
// @author Felix Mamani (felixddxd@gmail.com)
// @entity Pragma Invest S.A.
//
/*************************************************************/
'use strict'
import store from '../store/index'
import router from '../router/index'
import useQuasar from 'quasar/src/composables/use-quasar.js';import Platform from 'quasar/src/plugins/Platform.js';
import env from '../../config/env'

const util = {
  // Format number money
  numberMoney (number) {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    let result = formatter.format(number).split('$');
    return result[1];
  },

  // Verify rol user
  verifyRol (roles) {
    // ***** Roles del sistema *****
    // 1: ADMINISTRADOR
    // 2: USUARIO
    // 3: AUTORIZADOR
    // 4: REVISOR
    // 5: APROBADOR
    // 6: TESORERIA
    // 7: APROBADOR RENDICIONES
    // 8: ADMIN
    const user = store.getters['auth/user']
    let sw = false
    roles.forEach(item => {
      if (item == user.rol_id) {
        sw = true
      }
    })
    if (!sw) {
      router.push({name: '403'})
    }
  },

  // Verify if exist Business on application
  verifyBusiness () {
    const quasar = useQuasar()
    const empresa = quasar.localStorage.getItem('empresa')
    if (!empresa) {
      return false
    } else {
      return true
    }
  },

  // Verify permissions user
  verifyBanned (permission) {
    const user = store.getters['auth/user']
    if (user.banned.length > 0) {
      user.banned.forEach(item => {
        if (item.banned === permission) {
          router.push({name: '403'})
        }
      })
    }
  },
  
  // Return platform
  getPlatform () {
    let platform = 'W'
    if (Platform.is.platform === 'android') {
      platform = 'A'
    } else if (Platform.is.platform === 'iphone') {
      platform = 'I'
    } else {
      platform = 'W'
    }
    return platform
  },

  // Return last state
  getLastState (states) {
    let arrayStates = states[states.length - 1].estado.split('|')
    return arrayStates[1]
  },

  // Return Version App
  getVersion () {
    let version = ''
    if (Platform.is.platform === 'android') {
      version = env.VERSION_ANDROID
    } else if (Platform.is.platform === 'iphone') {
      version = env.VERSION_IOS
    } else {
      version = '0.0.1'
    }
    return version
  }
}

export default util;